/**
 * A redação fixa do documento impresso — os ANEXOS IA (p.80) e IB (p.81) do Termo de Referência.
 *
 * **Transcrita, não reescrita.** A fórmula de autorização é a frase que o modelo do contrato traz,
 * palavra por palavra: é ela que faz o papel autorizar a execução, e reescrevê-la "mais claro"
 * transformaria o documento numa carta parecida com uma ordem de serviço. O mesmo vale para os
 * títulos numerados das seções — quem confere o documento procura "4 – ESPECIFICAÇÃO DOS SERVIÇOS
 * E VOLUMES ESTIMADOS", e não "Itens".
 *
 * Fica fora do glossário pela regra do próprio glossário, como `textoDoTrp.ts`: é texto de um
 * documento só. O que a interface repete em outras telas continua vindo de `textosDaOs.ts`.
 */
export const DOCUMENTO_DA_OS = {
  tituloIa: 'MODELO DE ORDEM DE SERVIÇO — PROJETOS / SERVIÇOS ESPECIALIZADOS',
  tituloIb: 'MODELO DE ORDEM DE SERVIÇO — SUSTENTAÇÃO E INFRAESTRUTURA',
  anexoIa: 'ANEXO IA',
  anexoIb: 'ANEXO IB',

  secoes: {
    identificacao: '1 – IDENTIFICAÇÃO',
    requisitante: '2 – ÁREA REQUISITANTE',
    objetivo: '3 – OBJETIVO DA ORDEM DE SERVIÇO E META DE PRODUTIVIDADE',
    servicos: '4 – ESPECIFICAÇÃO DOS SERVIÇOS E VOLUMES ESTIMADOS',
    requisitos: '3 – REQUISITOS NÃO FUNCIONAIS OBRIGATÓRIOS',
    datas: '5 – DATAS E PRAZOS PREVISTOS',
    artefatos: '5 – ARTEFATOS / PRODUTOS',
    assinatura: 'ASSINATURA E ENCAMINHAMENTO DA DEMANDA',
  },

  rotulos: {
    numero: 'Nº da OS',
    emissao: 'Data de emissão',
    tipo: 'Tipo',
    contrato: 'Contrato',
    objeto: 'Objeto do Contrato',
    contratado: 'Contratado',
    cnpj: 'CNPJ',
    inicioVigencia: 'Início vigência',
    fimVigencia: 'Fim vigência',
    unidade: 'Unidade',
    solicitante: 'Solicitante',
    email: 'E-mail',
    numeroExterno: 'Nº no documento de origem',
    competencia: 'Mês de referência',
    fornecidos: 'Fornecidos',
    aGerar: 'A serem gerados e/ou atualizados',
    totalEstimado: 'Valor total estimado da OS:',
    somaDasLinhas: 'Soma das linhas declaradas:',
  },

  quadro: {
    item: 'Item',
    descricao: 'Descrição do serviço',
    metrica: 'Métrica',
    valorUnitario: 'Valor unitário (R$)',
    quantidade: 'Qtde. Estimada',
    valorTotal: 'Valor Total Estimado (R$)',
  },

  /**
   * A fórmula de autorização, literal (ANEXO IA, p.80; ANEXO IB, p.81).
   *
   * É a frase que autoriza a execução. Ela não muda entre os dois anexos, e não muda aqui.
   */
  autorizacao:
    'Autoriza-se a execução dos serviços correspondentes à presente OS, no período e nos ' +
    'quantitativos acima identificados.',

  assinaturas: {
    fiscal: 'Responsável pela demanda / Fiscal Requisitante',
    gestor: 'Gestor do Contrato',
    matricula: (numero: string) => `Matr.: ${numero}`,
    assinouEm: (quando: string) => `Assinatura registrada em ${quando}`,
  },

  local: 'Niterói',

  /**
   * O que este documento NÃO traz, e por quê.
   *
   * **Não é campo em branco.** É a mesma disciplina do indicador não apurado e da ressalva do TRP:
   * quando o sistema não tem o dado, ele diz que não tem e diz por quê, em vez de imprimir um traço
   * que se lê como afirmação. Numa folha que circula solta dentro de um processo administrativo
   * isso vale ainda mais — quem a receber não terá esta tela ao lado para perguntar.
   */
  ressalva: {
    titulo: 'O que este documento não traz',
    preposto:
      'O modelo do contrato tem uma linha para o preposto da contratada. Este sistema não guarda ' +
      'quem é o preposto: ele é designado por ato da contratada e comunicado à fiscalização fora ' +
      'daqui. A linha sai em branco, para ser preenchida por quem assina.',
    divisao:
      'A seção 6 do ANEXO IB — DIVISÃO por órgão — não é impressa. A palavra aparece uma única vez ' +
      'em 233 páginas do Termo de Referência, o contrato não diz o que essa repartição decide, e ' +
      'nenhum documento do contrato a preencheu até hoje. Imprimir células vazias ali seria ' +
      'afirmar uma repartição que ninguém definiu.',
    cronograma:
      'O cronograma de execução linha a linha do ANEXO IA não é impresso: não existe ordem de ' +
      'serviço de projeto neste contrato, e o sistema não registra tarefas de um processo que ' +
      'ninguém executou.',
    conferencia:
      'Quando o valor total de uma linha difere de valor unitário × quantidade, os dois números ' +
      'aparecem. O documento assinado é o que vale; a conferência é do sistema, e ele não corrige ' +
      'nem esconde nenhum dos dois.',
  },
} as const
